[
  {
    "id": 4850,
    "uuid": "0a97af92-1467-4fa5-897d-426fc94a7fcc",
    "hitokoto": "一本书上每多一个公式，就会减少一半读者。",
    "type": "k",
    "from": "名人名言",
    "from_who": "霍金",
    "creator": "坐凳人",
    "creator_uid": 4832,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581041131",
    "length": 20
  },
  {
    "id": 4853,
    "uuid": "7ee06531-58a7-4e0b-89ad-923c871c2b90",
    "hitokoto": "人生用特写镜头来看是悲剧，长镜头来看则是喜剧。",
    "type": "k",
    "from": "名人名言",
    "from_who": "卓别林",
    "creator": "坐凳人",
    "creator_uid": 4832,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580979011",
    "length": 23
  },
  {
    "id": 5006,
    "uuid": "b45b4ace-c1f7-4feb-8ca2-7b2dc8c728e0",
    "hitokoto": "那些听不见音乐的人以为跳舞的人疯了。",
    "type": "k",
    "from": "上帝死了",
    "from_who": "弗里德里希·威廉·尼采",
    "creator": "scvoet",
    "creator_uid": 1713,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581216160",
    "length": 18
  },
  {
    "id": 5020,
    "uuid": "8ecd9ac2-8685-4991-a6a6-3c75cbc0e118",
    "hitokoto": "奇怪的是，当他死去，所有人才开始爱他。",
    "type": "k",
    "from": "哲学",
    "from_who": "崔雪莉",
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580309580",
    "length": 19
  },
  {
    "id": 5021,
    "uuid": "6e8d5dca-6d65-479f-ba05-55db04987ae9",
    "hitokoto": "为什么要担心？如果努力了，担心不会让结果变得更好。",
    "type": "k",
    "from": "迪士尼",
    "from_who": null,
    "creator": "CY-Track",
    "creator_uid": 4740,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580263026",
    "length": 25
  },
  {
    "id": 5075,
    "uuid": "9a8784c4-4c85-4fd5-869e-5067a55ae483",
    "hitokoto": "生活不可能像你想象得那么好，但也不会像你想象得那么糟。我觉得人的脆弱和坚强都超乎自己的想象。有时，我可能脆弱得一句话就泪流满面；有时，也发现自己咬着牙走了很长的路。",
    "type": "k",
    "from": "一生",
    "from_who": "莫泊桑",
    "creator": "Chukaland",
    "creator_uid": 4959,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582008178",
    "length": 82
  },
  {
    "id": 5101,
    "uuid": "fcc0e9df-3055-4a0d-a446-7c04c63bfd40",
    "hitokoto": "知道为什么婴儿出生的时候都会握着手痛哭吗？因为又要来这世间走一遭。",
    "type": "k",
    "from": "",
    "from_who": "zo",
    "creator": "桃黑亭",
    "creator_uid": 5031,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582697173",
    "length": 33
  },
  {
    "id": 5120,
    "uuid": "55c9ce9a-58fb-4fd7-9ba7-e81202b353e3",
    "hitokoto": "爱欲于人，犹如执炬，逆风而行，必有烧手之患",
    "type": "k",
    "from": "四十二章经",
    "from_who": null,
    "creator": "sparks",
    "creator_uid": 4670,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1579231690",
    "length": 21
  },
  {
    "id": 5134,
    "uuid": "9c5da99a-4600-4e7c-b9ae-6561ffc64a9b",
    "hitokoto": "Sow an act, and you reap a habit. Sow a habit, and you reap a character. Sow a character, and you reap a destiny.",
    "type": "k",
    "from": "Charles Reade",
    "from_who": null,
    "creator": "alterem",
    "creator_uid": 4351,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1574840413",
    "length": 113
  },
  {
    "id": 5152,
    "uuid": "0047026d-0fcc-4226-a77d-98d7550e3d54",
    "hitokoto": "Innovation distinguishes between a leader and a follower. 领袖和跟风者的区别就在于创新。",
    "type": "k",
    "from": "乔布斯",
    "from_who": null,
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575601688",
    "length": 73
  },
  {
    "id": 5153,
    "uuid": "be8e6a2d-9bfd-467a-95e2-3dcf357a6c5a",
    "hitokoto": "We're here to put a dent in the universe. Otherwise why else even be here? 活着就是为了改变世界，难道还有其他原因吗？",
    "type": "k",
    "from": "乔布斯",
    "from_who": null,
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575601658",
    "length": 96
  },
  {
    "id": 5164,
    "uuid": "5958561f-d704-4fcb-9a05-a69e6ebdfbc0",
    "hitokoto": "我希望庆国之民，有真理可循，知礼仪，守仁心，不以钱财论成败，不因权势而屈从，同情弱小，痛恨不平，危难时坚心志，无人处常自省；我希望这世间，再无压迫束缚，凡生于世，都能有活着的权利，有自由的权利，亦有幸福的权利。",
    "type": "k",
    "from": "庆余年",
    "from_who": "猫腻",
    "creator": "澄泓",
    "creator_uid": 3410,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582869846",
    "length": 105
  },
  {
    "id": 5186,
    "uuid": "9a5820e3-0e28-4be3-8562-09f97c1c1385",
    "hitokoto": "那一千年完了，撒但必从监牢里被释放，出来要迷惑地上四方的列国，就是歌革和玛各，叫他们聚集争战。他们的人数多如海沙。",
    "type": "k",
    "from": "圣经",
    "from_who": null,
    "creator": "夜隐辉",
    "creator_uid": 5181,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583124189",
    "length": 57
  },
  {
    "id": 5204,
    "uuid": "739cb56b-3e22-4dbe-b018-861acf248b2e",
    "hitokoto": "我们是独立的个体，却不是孤独的存在。",
    "type": "k",
    "from": "千里共良宵",
    "from_who": null,
    "creator": "2247",
    "creator_uid": 5148,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583290826",
    "length": 18
  },
  {
    "id": 5244,
    "uuid": "da22aded-e58b-4b9d-8e2d-55d302ea95ed",
    "hitokoto": "最折磨人的或许不是一场惨烈战争，而是烦琐的日常生活。",
    "type": "k",
    "from": "亦舒",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583784351",
    "length": 26
  },
  {
    "id": 5363,
    "uuid": "ff7c91a4-89db-43c8-a252-28346f8504de",
    "hitokoto": "人类从历史中学到的唯一教训，就是人类无法从历史中学到任何教训。",
    "type": "k",
    "from": "历史哲学",
    "from_who": "黑格尔",
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585317957",
    "length": 31
  },
  {
    "id": 5411,
    "uuid": "970693f2-d35f-4ab9-a980-0969698b3041",
    "hitokoto": "幸运的人一生都在被童年治愈，不幸的人一生都在治愈童年。",
    "type": "k",
    "from": "阿尔弗雷德·阿德勒",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585802732",
    "length": 27
  },
  {
    "id": 5412,
    "uuid": "e4a14ce3-dd62-4ac0-b8c5-2d7f78c96b28",
    "hitokoto": "人生没有定数的，社会不会抛弃努力的人，只要努力，人生都会慷慨地馈赠让你满意的礼物！",
    "type": "k",
    "from": "知乎",
    "from_who": "倩Sur",
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585712144",
    "length": 41
  },
  {
    "id": 5949,
    "uuid": "529454f8-32b7-4074-ac21-48dd6d767945",
    "hitokoto": "不管风吹浪打，胜似闲庭信步。",
    "type": "k",
    "from": "毛泽东语录精选",
    "from_who": "毛泽东",
    "creator": "微笑阿猪",
    "creator_uid": 5861,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586611853",
    "length": 14
  },
  {
    "id": 5950,
    "uuid": "9685ca1d-7815-4f96-9ac7-f70f6cff0f2e",
    "hitokoto": "多少事，从来急，天地转，光阴迫，一万年太久，只争朝夕。",
    "type": "k",
    "from": "毛泽东语录",
    "from_who": "毛泽东",
    "creator": "微笑阿猪",
    "creator_uid": 5861,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586611930",
    "length": 27
  },
  {
    "id": 5951,
    "uuid": "3664f3f9-f1d1-438b-a707-821f32a34ee2",
    "hitokoto": "历史的发展是不以人的意志为转移的。",
    "type": "k",
    "from": "毛泽东",
    "from_who": "毛泽东",
    "creator": "微笑阿猪",
    "creator_uid": 5861,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586612015",
    "length": 17
  },
  {
    "id": 5952,
    "uuid": "8f9c2e57-829c-4493-ac43-f4ad77796a37",
    "hitokoto": "没有调查就没有发言权。",
    "type": "k",
    "from": "毛泽东",
    "from_who": "毛泽东",
    "creator": "微笑阿猪",
    "creator_uid": 5861,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586612047",
    "length": 11
  },
  {
    "id": 5953,
    "uuid": "096dec20-44f3-4679-bc9f-918343d09507",
    "hitokoto": "世界是你们的，也是我们的，但是归根结底是你们的。你们青年人朝气蓬勃，正在兴旺时期，好像早晨八九点钟的太阳。希望寄托在你们身上。",
    "type": "k",
    "from": "毛泽东",
    "from_who": "毛泽东",
    "creator": "微笑阿猪",
    "creator_uid": 5861,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586612161",
    "length": 63
  },
  {
    "id": 5962,
    "uuid": "de606f8f-2d26-4d94-b4b6-efc8262b3f0a",
    "hitokoto": "以有涯随无涯，殆已！已而为知者，殆而已矣！",
    "type": "k",
    "from": "庄子",
    "from_who": "庄周",
    "creator": "CloverGit",
    "creator_uid": 5915,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586998830",
    "length": 21
  },
  {
    "id": 6017,
    "uuid": "b8ebd342-86ed-44b2-a376-6ac12c29f1b5",
    "hitokoto": "个人能力有大小，但只要有这点精神，就是一个高尚的人，一个纯粹的人，一个有道德的人，一个脱离了低级趣味的人，一个有益于人民的人。",
    "type": "k",
    "from": "纪念白求恩",
    "from_who": "毛泽东",
    "creator": "微笑阿猪",
    "creator_uid": 5861,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586612293",
    "length": 63
  },
  {
    "id": 6032,
    "uuid": "76f217c2-1382-4f27-bb5a-a0586567db4a",
    "hitokoto": "很多人都认为别人的东西总好过自己的东西，这或许是想要拥有所有东西的理由。",
    "type": "k",
    "from": "网络",
    "from_who": "satey",
    "creator": "huangsatey",
    "creator_uid": 5916,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587000826",
    "length": 36
  },
  {
    "id": 6041,
    "uuid": "4d4dc771-98ed-4860-a4ab-7ee652dd522a",
    "hitokoto": "绝望的人没有故乡。",
    "type": "k",
    "from": "加缪手记·第二卷",
    "from_who": "阿尔贝·加缪",
    "creator": "溟YX",
    "creator_uid": 5965,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587344972",
    "length": 9
  },
  {
    "id": 6175,
    "uuid": "db2c4ea6-ce7d-4637-8aa8-456f2e4ec874",
    "hitokoto": "知识有两种，一种是你知道的，一种是你知道在哪里能找到的！",
    "type": "k",
    "from": "塞缪尔·约翰逊",
    "from_who": null,
    "creator": "Mr96",
    "creator_uid": 4362,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589939352",
    "length": 28
  },
  {
    "id": 6256,
    "uuid": "b2f3834f-5f52-4b62-bb3c-f9fb98901419",
    "hitokoto": "我们在努力扩大自己，以靠近，以触及我们自身以外的世界。",
    "type": "k",
    "from": "豪尔赫·路易斯·博尔赫斯",
    "from_who": "博尔赫斯谈话录",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592126239",
    "length": 27
  },
  {
    "id": 6269,
    "uuid": "d0e673d3-150e-4b7c-a05d-b223b0ba4428",
    "hitokoto": "吾生三愿，纯朴却激越:一曰渴望爱情，二曰求索知识，三曰悲悯吾类之无尽苦难。",
    "type": "k",
    "from": "网络",
    "from_who": "伯特兰·罗素",
    "creator": "Declan",
    "creator_uid": 6466,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592117668",
    "length": 37
  },
  {
    "id": 6401,
    "uuid": "4241949c-f42e-4357-940d-164a1293302d",
    "hitokoto": "人类从历史中学到的唯一教训，就是人类无法从历史中学到任何教训。",
    "type": "k",
    "from": "历史哲学",
    "from_who": "黑格尔",
    "creator": "arsteara",
    "creator_uid": 6860,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596311677",
    "length": 31
  },
  {
    "id": 6414,
    "uuid": "8e6ef443-7fde-4141-8a6d-163da578e59e",
    "hitokoto": "若以色见我，以音声求我，是人行邪道，不能见如来。",
    "type": "k",
    "from": "金刚经",
    "from_who": "鸠摩罗什",
    "creator": "范.那内海姆",
    "creator_uid": 2913,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596096068",
    "length": 24
  },
  {
    "id": 6418,
    "uuid": "4a14fd11-9e45-4935-bd16-da864c361fe9",
    "hitokoto": "无垢清净光，慧日破诸暗，能伏灾风火，普明照世间。",
    "type": "k",
    "from": "法华经",
    "from_who": "鸠摩罗什",
    "creator": "范.那内海姆",
    "creator_uid": 2913,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596274765",
    "length": 24
  },
  {
    "id": 6459,
    "uuid": "ea89f6db-0849-48e1-812e-d66533d8be33",
    "hitokoto": "谎言重复一千遍就成了真理。",
    "type": "k",
    "from": "纳粹德国宣传部长",
    "from_who": "戈培尔",
    "creator": "Serastan",
    "creator_uid": 7394,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1602079729",
    "length": 13
  },
  {
    "id": 6462,
    "uuid": "0e286fe6-ca51-42bb-8f78-134a1bd98873",
    "hitokoto": "后代人的权利远比当代人的欲望更重要。",
    "type": "k",
    "from": "《黄石国家公园法》的理念",
    "from_who": null,
    "creator": "linsir",
    "creator_uid": 978,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1597210376",
    "length": 18
  },
  {
    "id": 6469,
    "uuid": "64497f0d-816b-4097-857c-7fc65db84b10",
    "hitokoto": "物质决定意识，意识反作用于物质",
    "type": "k",
    "from": "唯物主义哲学",
    "from_who": null,
    "creator": "雨啸青锋",
    "creator_uid": 5808,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602937354",
    "length": 15
  },
  {
    "id": 6477,
    "uuid": "f765507c-8ea5-4058-9304-0d3ca6db2dc1",
    "hitokoto": "实践是检验真理的唯一标准。",
    "type": "k",
    "from": "光明日报",
    "from_who": null,
    "creator": "雨啸青锋",
    "creator_uid": 5808,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602937562",
    "length": 13
  },
  {
    "id": 6503,
    "uuid": "6c7697d2-46e1-413b-a40c-11a999bfd0db",
    "hitokoto": "我们把世界看错，反说它欺骗了我们。",
    "type": "k",
    "from": "飞鸟集",
    "from_who": "泰戈尔",
    "creator": "恏戋余",
    "creator_uid": 7045,
    "reviewer": 6844,
    "commit_from": "app",
    "created_at": "1598342433",
    "length": 17
  },
  {
    "id": 6620,
    "uuid": "2f5aac92-0b05-44bc-aaa0-93af289337cd",
    "hitokoto": "一件事物与其自身完全一致",
    "type": "k",
    "from": "逻辑哲学论",
    "from_who": null,
    "creator": "i",
    "creator_uid": 6605,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1604177291",
    "length": 12
  },
  {
    "id": 6626,
    "uuid": "d6cb8cd9-df68-4b4a-b45e-e56cebddf89d",
    "hitokoto": "除了没用的肉体自杀和精神逃避，第三种自杀的态度是坚持奋斗，对抗人生的荒谬。",
    "type": "k",
    "from": "加缪手记",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266491",
    "length": 37
  },
  {
    "id": 6670,
    "uuid": "b5f3e632-6d18-44ad-81fa-9fc0e114dc3f",
    "hitokoto": "巧合是上帝默默操控世界的方式。",
    "type": "k",
    "from": "佚名",
    "from_who": "爱因斯坦",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604752694",
    "length": 15
  },
  {
    "id": 6671,
    "uuid": "05c08fc7-67c1-4c28-bae4-5faddbe731db",
    "hitokoto": "不是所有怪物一开始就是怪物，也不是所有怪物看起来都像怪物。有些人会把怪物的一面放在心里。",
    "type": "k",
    "from": "外婆的道歉信",
    "from_who": "Fredrik Backman",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604752879",
    "length": 44
  },
  {
    "id": 6674,
    "uuid": "130634bb-3a87-4564-8717-54fc014b9592",
    "hitokoto": "人能够能动地认识世界；人能够能动地改造世界。",
    "type": "k",
    "from": "主观能动性",
    "from_who": null,
    "creator": "雨啸青锋",
    "creator_uid": 5808,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604753345",
    "length": 22
  },
  {
    "id": 6675,
    "uuid": "83e5245e-3802-42a7-8cc9-b2328cf805d3",
    "hitokoto": "哲学的基本问题是思维和存在的关系问题。",
    "type": "k",
    "from": "哲学的基本问题",
    "from_who": null,
    "creator": "雨啸青锋",
    "creator_uid": 5808,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604753412",
    "length": 19
  },
  {
    "id": 6679,
    "uuid": "3a25cc2e-410c-428f-bf14-b29406577ffe",
    "hitokoto": "木秀于林，风必摧之。如果身边都是木，就是不一样的风景。 鹤立鸡群，倍受排挤。你可以选择离开鸡群。 人生最浪费生命的就是在没有选择时，进入某一个团体一段时间，却非逼着自己浪费时间做些蠢事去合群。 道不同不相为谋，人贵在有自知之明。",
    "type": "k",
    "from": "万彦文",
    "from_who": null,
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604754154",
    "length": 114
  },
  {
    "id": 6697,
    "uuid": "5d054917-0f24-4df1-ac08-e819f5fbd9f0",
    "hitokoto": "自身拥有越丰富，他在别人身上所能发现得到的就越少。",
    "type": "k",
    "from": "人类的智慧",
    "from_who": "亚瑟・叔本华",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604800688",
    "length": 25
  },
  {
    "id": 6699,
    "uuid": "96ad5c2f-ad9f-4f2b-a9c8-987af784442e",
    "hitokoto": "人性一个最特别的弱点就是：在意别人如何看待自己。",
    "type": "k",
    "from": "亚瑟・叔本华",
    "from_who": null,
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604800809",
    "length": 24
  },
  {
    "id": 6701,
    "uuid": "dd4ed420-6e48-41e5-9f8d-b1aaadffcc96",
    "hitokoto": "我们没有永恒的朋友，也没有永恒的敌人，只有永恒的利益。",
    "type": "k",
    "from": "亨利·坦普尔",
    "from_who": null,
    "creator": "皮皮参",
    "creator_uid": 6402,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604837840",
    "length": 27
  },
  {
    "id": 6743,
    "uuid": "98d01b71-8441-43a2-8cbf-616c0d213c55",
    "hitokoto": "黑色世界唯有东方的曙光。",
    "type": "k",
    "from": "Bilibili",
    "from_who": "Google Translate",
    "creator": "一切幻影",
    "creator_uid": 5371,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606023056",
    "length": 12
  },
  {
    "id": 6810,
    "uuid": "c0cfe4e0-517e-427a-a006-23bef2b5280b",
    "hitokoto": "Stay hungry, Stay foolish.",
    "type": "k",
    "from": "乔布斯斯坦福大学毕业演讲",
    "from_who": "史蒂夫-乔布斯",
    "creator": "Abyss",
    "creator_uid": 8803,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1616846581",
    "length": 26
  },
  {
    "id": 6853,
    "uuid": "a76f52f7-4095-47e2-b829-af9dd7c38688",
    "hitokoto": "甲之蜜糖，乙之砒霜。",
    "type": "k",
    "from": "曼陀罗",
    "from_who": "亦舒",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607226665",
    "length": 10
  },
  {
    "id": 6875,
    "uuid": "aca08ba3-cdb1-4283-8f4c-2da7b3ef236f",
    "hitokoto": "生命是一团欲望，欲望不满足便痛苦，满足便无聊。人生就在痛苦和无聊之间摇摆。",
    "type": "k",
    "from": "叔本华 ​​",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266562",
    "length": 37
  },
  {
    "id": 6902,
    "uuid": "8394d83d-af0c-4757-8f6a-807dab8bdaf6",
    "hitokoto": "物质与意识的辩证关系：物质决定意识，意识反作用于物质。",
    "type": "k",
    "from": "唯物主义哲学",
    "from_who": null,
    "creator": "雨啸青锋",
    "creator_uid": 5808,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607829581",
    "length": 27
  },
  {
    "id": 6922,
    "uuid": "72fd3d40-7027-40a8-8c33-cbf4e2ee8002",
    "hitokoto": "眼睛是心灵的窗户。",
    "type": "k",
    "from": "达芬奇",
    "from_who": null,
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609720620",
    "length": 9
  },
  {
    "id": 6923,
    "uuid": "0a6fab16-4432-49df-a670-b205ae12d337",
    "hitokoto": "我以为别人尊重我，是因为我很优秀。后来才明白，别人尊重我，是因为别人很优秀。",
    "type": "k",
    "from": "理解尊重",
    "from_who": "鲁迅",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609720869",
    "length": 38
  },
  {
    "id": 7001,
    "uuid": "acc05888-b576-4cd1-b991-b6fdcdd26e36",
    "hitokoto": "君子不器。",
    "type": "k",
    "from": "论语·为政",
    "from_who": "孔子",
    "creator": "徐凤年",
    "creator_uid": 8400,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612235959",
    "length": 5
  },
  {
    "id": 7046,
    "uuid": "1bbed6ba-bf08-43d3-9538-134340f0c526",
    "hitokoto": "人生而自由，却无往不在枷锁中。",
    "type": "k",
    "from": "社会契约论",
    "from_who": "卢梭",
    "creator": "luo",
    "creator_uid": 8515,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613622005",
    "length": 15
  },
  {
    "id": 7047,
    "uuid": "94422198-895d-459f-98e2-f0d36bb52f21",
    "hitokoto": "所谓辉煌的人生，不过是欲望的囚徒。",
    "type": "k",
    "from": "网络",
    "from_who": "叔本华",
    "creator": "luo",
    "creator_uid": 8515,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613624478",
    "length": 17
  },
  {
    "id": 7081,
    "uuid": "188c5217-9f90-430d-8417-759afa4fac9c",
    "hitokoto": "我们的科学永远只是找到近似真理。",
    "type": "k",
    "from": "爱因斯坦",
    "from_who": null,
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1614946456",
    "length": 16
  },
  {
    "id": 7110,
    "uuid": "730de2b2-e3ed-42ad-b647-bd4c91ab04eb",
    "hitokoto": "谨记自己总会死去，是让自己避免陷入“人生有所失”思考的最佳方法。",
    "type": "k",
    "from": "乔布斯名言",
    "from_who": "史蒂夫-乔布斯",
    "creator": "Abyss",
    "creator_uid": 8803,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616846675",
    "length": 32
  },
  {
    "id": 7173,
    "uuid": "49eff9ca-7145-4c5f-8e62-d3dca63537fa",
    "hitokoto": "即使人生是一场悲剧，也应该笑着把人生演完。",
    "type": "k",
    "from": "查拉图斯特如是说",
    "from_who": "尼采",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614946509",
    "length": 21
  },
  {
    "id": 7203,
    "uuid": "24b3813e-17cf-454c-8351-0a718bab0fdc",
    "hitokoto": "师者，所以传道授业解惑也。",
    "type": "k",
    "from": "师说",
    "from_who": "韩愈",
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1619420759",
    "length": 13
  },
  {
    "id": 7220,
    "uuid": "94804dc7-f661-4c14-a995-c44405fd671b",
    "hitokoto": "因为不可能，所以才值得相信。",
    "type": "k",
    "from": "浮士德",
    "from_who": "歌德",
    "creator": "亚亚努阿",
    "creator_uid": 8848,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617029878",
    "length": 14
  },
  {
    "id": 7226,
    "uuid": "64559b13-fe87-44fd-a745-d48fb6c6895a",
    "hitokoto": "人类侥幸拥有了智慧，就应该善用它。",
    "type": "k",
    "from": "意林",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620182739",
    "length": 17
  },
  {
    "id": 7227,
    "uuid": "59acaebe-012e-49aa-aae6-a25aced01ffb",
    "hitokoto": "虽然人生在世有种种不如意，但你仍可以在幸福与不幸中做选择。",
    "type": "k",
    "from": "写给新的一年",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620184822",
    "length": 29
  },
  {
    "id": 7250,
    "uuid": "5562841a-6724-477f-8708-9243f7a76deb",
    "hitokoto": "我的辫子长在头上，诸君的辫子长在心里。",
    "type": "k",
    "from": "觉醒年代",
    "from_who": "辜鸿铭",
    "creator": "社会主义好",
    "creator_uid": 9813,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1626884230",
    "length": 19
  },
  {
    "id": 7251,
    "uuid": "43574bd6-b563-45ab-9398-b09f33234f7a",
    "hitokoto": "我们登上并非我们所选择的舞台，演出并非我们所选择的剧本。",
    "type": "k",
    "from": "Enchiridion",
    "from_who": "爱比克泰德",
    "creator": "Damon",
    "creator_uid": 9899,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1627354139",
    "length": 28
  },
  {
    "id": 7252,
    "uuid": "bf7a7862-0b1c-4e7b-9df3-431a9148bed8",
    "hitokoto": "理性的人追求的并非快乐，而只是避免痛苦。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628137131",
    "length": 20
  },
  {
    "id": 7255,
    "uuid": "1201d951-0eaa-4f23-beb7-b2999e4b6557",
    "hitokoto": "从来不会生气的人，注定终生遭受欺凌和压制，直至被摧毁和消灭。",
    "type": "k",
    "from": "少有人走的路：心智成熟的旅程",
    "from_who": "M·斯科特·派克",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628137612",
    "length": 30
  },
  {
    "id": 7256,
    "uuid": "3246a54e-10cf-49f7-9348-3ff3712cbc38",
    "hitokoto": "勇气，并不意味着永不恐惧，而是面对恐惧时能够坦然行动，克服畏缩心理，大步走向未知的未来。",
    "type": "k",
    "from": "少有人走的路：心智成熟的旅程",
    "from_who": "M·斯科特·派克",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628137851",
    "length": 44
  },
  {
    "id": 7257,
    "uuid": "d878773c-fdbb-4df1-a5e5-56643779b097",
    "hitokoto": "君不见，教堂的梁柱，它们各自分开耸立，却能支撑教堂不倒。君不见，橡树与松柏，也不在彼此的阴影中成长。",
    "type": "k",
    "from": "少有人走的路：心智成熟的旅程",
    "from_who": "M·斯科特·派克",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628137913",
    "length": 50
  },
  {
    "id": 7258,
    "uuid": "b3c1c419-b562-4e9b-b812-383351c065ba",
    "hitokoto": "很多人都只会观看，而不会思考。他们如果手边没有雪茄的话，就会用制造噪音来感觉自己的存在。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628138215",
    "length": 44
  },
  {
    "id": 7259,
    "uuid": "6194a801-c4df-4135-9eb6-be2bbe2aa173",
    "hitokoto": "如果我们对一个人的本质加以彻底谴责的话，那这个人唯一的选择就是视我们为敌人。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628138238",
    "length": 38
  },
  {
    "id": 7265,
    "uuid": "5d5523d1-e586-42dd-9b7a-faf4571d1090",
    "hitokoto": "野蛮人之间人吃人，文明人之间人骗人。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628154622",
    "length": 18
  },
  {
    "id": 7266,
    "uuid": "09636259-5f9e-4e5e-b78a-48bedf0e3bf3",
    "hitokoto": "如果预计中的不幸没有发生的话，我们就会收获意外的喜悦。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628154241",
    "length": 27
  },
  {
    "id": 7267,
    "uuid": "00f5e655-c46f-40f3-9587-0fd6aca0dd10",
    "hitokoto": "哪怕一百个愚笨的人在一起聚会，也无法产生一个智慧的人。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628154260",
    "length": 27
  },
  {
    "id": 7269,
    "uuid": "77fdf725-c11d-4d2f-afd7-3b2b2c3cc8c0",
    "hitokoto": "只有当不幸真的到来时，我们才会怀念和渴望那些逝去的美好时光。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628160239",
    "length": 30
  },
  {
    "id": 7270,
    "uuid": "e1fbeb24-a0a2-406f-8b44-397d5e876a98",
    "hitokoto": "对于我们的幸福来说，别人的看法在本质上来讲并不十分重要。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628159989",
    "length": 28
  },
  {
    "id": 7271,
    "uuid": "3ce69902-689e-4956-b157-e398eea454ce",
    "hitokoto": "我们感到不满的原因就在于我们试图不断地提高自己的要求。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628159941",
    "length": 27
  },
  {
    "id": 7272,
    "uuid": "24c5ebc8-d980-4401-b35b-1eb13ae6ea9a",
    "hitokoto": "当一个人的意识中还不存在对某种东西的需求时，他就不会感到这方面的缺乏。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628159920",
    "length": 35
  },
  {
    "id": 7273,
    "uuid": "4c13716e-b34b-4407-9e2a-490e63f52c7d",
    "hitokoto": "人的精神思想方面的优势越大，给无聊留下的空间就越小。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628159766",
    "length": 26
  },
  {
    "id": 7274,
    "uuid": "4d4e35ab-c360-402d-90e6-77e519a90a6d",
    "hitokoto": "命运负责洗牌和发牌，而我们只能出牌。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306502",
    "length": 18
  },
  {
    "id": 7275,
    "uuid": "48a1ad9c-54eb-4dd9-a389-c2e12c7244a8",
    "hitokoto": "不管人生呈现出什么样貌，人生的构成要素都是一样的。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306484",
    "length": 25
  },
  {
    "id": 7276,
    "uuid": "a3aad3af-9ae9-46af-9296-ceedca152d34",
    "hitokoto": "忘掉一个人的劣根性就像把千辛万苦赚来的钱扔掉一样。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306472",
    "length": 25
  },
  {
    "id": 7277,
    "uuid": "12404b6b-68a4-43b6-85ac-2b0b816ab1f9",
    "hitokoto": "如果一个人表现得粗鲁、没有礼貌，那他就像脱光了衣服，赤身裸体地出现在人前。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306449",
    "length": 37
  },
  {
    "id": 7278,
    "uuid": "eb11da1b-26b0-486c-b9fe-f57ae0b35e81",
    "hitokoto": "一个人的自身越是丰富，就越难以忍受世俗常规的安排。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306382",
    "length": 25
  },
  {
    "id": 7279,
    "uuid": "e689f682-5334-474b-8be6-8911407a6bf9",
    "hitokoto": "装作拥有某样品质，实际上就等于承认了自己并没有这样品质。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306360",
    "length": 28
  },
  {
    "id": 7280,
    "uuid": "9b8a7e0d-d462-48c2-a2c4-1e2b9383b1e5",
    "hitokoto": "人生中的各种事件就像万花筒里的景象一样，每次转动都能看到不一样的画面，但实际上，展现在我们眼前的是同一个万花筒。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306509",
    "length": 56
  },
  {
    "id": 7281,
    "uuid": "64f0dd63-8602-411a-85f3-c6c4c25e8882",
    "hitokoto": "最值得一个人骄傲的实际上是他的精神思想素质，因为人相比于动物的优势就体现在这一方面。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306434",
    "length": 42
  },
  {
    "id": 7282,
    "uuid": "2c5dd927-a145-45c6-ab80-3f68e16267ef",
    "hitokoto": "如果很长时间不见面，就连我们最好的朋友也会在时间的流逝中逐渐变成抽象的概念。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628306414",
    "length": 38
  },
  {
    "id": 7293,
    "uuid": "7eb802f7-b5fd-45fe-85bb-ea90e6cb0465",
    "hitokoto": "当你凝望深渊时，深渊也在凝望着你。与魔鬼战斗的人，谨防自身变成魔鬼。",
    "type": "k",
    "from": "《善恶的彼岸》",
    "from_who": "弗里德里希·威廉·尼采",
    "creator": "A_Pi",
    "creator_uid": 8981,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1618132757",
    "length": 34
  },
  {
    "id": 7296,
    "uuid": "4b48ae48-a809-43ef-9b67-7665c66838e1",
    "hitokoto": "只要结局有可能变好，我们就不能胆怯，就像只要能看到一点蓝天，就不能对天气绝望。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628421333",
    "length": 39
  },
  {
    "id": 7297,
    "uuid": "ed9119a0-0051-421a-8863-710e82edba79",
    "hitokoto": "就算天塌下来变成一片废墟，他的脸色也不会有丝毫变化。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628421050",
    "length": 26
  },
  {
    "id": 7298,
    "uuid": "f41112ec-fe2d-4d1b-9133-779169fc6416",
    "hitokoto": "青年时期，他们觉得人群遗弃了自己；成年之后，却觉得自己逃离了人群。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628420969",
    "length": 33
  },
  {
    "id": 7299,
    "uuid": "acd4ef6e-a29a-4e72-a7a1-0c7a5781d244",
    "hitokoto": "好比一年中的春天是悠长而烦闷的，生命的春天也一样漫长而令人烦躁。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628420846",
    "length": 32
  },
  {
    "id": 7300,
    "uuid": "a7463e8c-f4c4-4bb2-90f6-1f032a2b2f06",
    "hitokoto": "一年中和一生中的秋天，时光很短暂，但是更加晴朗而缺少变化。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628420797",
    "length": 29
  },
  {
    "id": 7301,
    "uuid": "8eef8fac-63ff-442c-b35e-e2de4d0be534",
    "hitokoto": "无论我们能活多久，我们能够享受的只有无法分割的此刻，此外别无其他。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628420730",
    "length": 33
  },
  {
    "id": 7302,
    "uuid": "8df3fff0-6cd5-4c11-93ef-84411b681923",
    "hitokoto": "那些根据世俗标准制定的伟大或渺小，尊贵或低微，没有太大的差别。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628420714",
    "length": 31
  },
  {
    "id": 7303,
    "uuid": "33d7b883-15cb-4739-90c9-3be0d1a42db4",
    "hitokoto": "很多事只是最初看起来有意义，但经过多次重复就慢慢失去了意义。",
    "type": "k",
    "from": "人生的智慧",
    "from_who": "叔本华",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628420696",
    "length": 30
  },
  {
    "id": 7316,
    "uuid": "7dc1ad21-cd76-4733-ba33-c4909a96b290",
    "hitokoto": "知识虽然可以带来幸福，但假如把它压缩成药丸子灌下去，就丧失了乐趣。",
    "type": "k",
    "from": "沉默的大多数",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620184289",
    "length": 33
  },
  {
    "id": 7317,
    "uuid": "4ae357db-29bc-464c-a69a-42c5acadce29",
    "hitokoto": "认真的思索，真诚的明辨是非，有这种态度，大概可算是善良吧。",
    "type": "k",
    "from": "沉默的大多数",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620184419",
    "length": 29
  },
  {
    "id": 7318,
    "uuid": "33b805a1-11b3-4940-8e74-283c08b76511",
    "hitokoto": "信心这个东西，什么时候都像个高楼大厦，但是里面会长白蚁。",
    "type": "k",
    "from": "沉默的大多数",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620184503",
    "length": 28
  },
  {
    "id": 7319,
    "uuid": "355f0550-8b13-438c-8618-fbfa4eebc1cc",
    "hitokoto": "思索是一道大门，通向世界上没有的东西，通到现在人类想不到的地方。",
    "type": "k",
    "from": "沉默的大多数",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620185436",
    "length": 32
  },
  {
    "id": 7320,
    "uuid": "d97561d8-b4e9-46f5-addf-1d4d946dd946",
    "hitokoto": "千万丈的大厦总要有片奠基石，最初的爱好无可替代。",
    "type": "k",
    "from": "我的精神家园",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620185683",
    "length": 24
  },
  {
    "id": 7321,
    "uuid": "0458669a-bec5-4781-8b21-c739c3435da2",
    "hitokoto": "似水流年是一个人所有的一切，只有这个东西，才真正归你所有。",
    "type": "k",
    "from": "似水流年",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620184899",
    "length": 29
  },
  {
    "id": 7322,
    "uuid": "b35caca2-09b3-4728-9f22-8ae4684a8153",
    "hitokoto": "人的一切痛苦，本质上都是对自己无能的愤怒。",
    "type": "k",
    "from": "意林",
    "from_who": "王小波",
    "creator": "Damianyang",
    "creator_uid": 9192,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620183789",
    "length": 21
  },
  {
    "id": 7324,
    "uuid": "483c691a-d898-428c-8ebc-51efe05f9e7a",
    "hitokoto": "那些听不见音乐的人认为那些跳舞的人疯了。",
    "type": "k",
    "from": "笑：论滑稽的意义",
    "from_who": "亨利·柏格森",
    "creator": "折影轻梦",
    "creator_uid": 9975,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628510764",
    "length": 20
  },
  {
    "id": 7380,
    "uuid": "c408e4a6-f79e-47a6-85d3-15b863964023",
    "hitokoto": "纵使天光终将熄灭，我们也要歌颂太阳。",
    "type": "k",
    "from": "我来到这世上为的是看太阳",
    "from_who": "巴尔蒙特",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616761875",
    "length": 18
  },
  {
    "id": 7381,
    "uuid": "1aac8a8f-f27c-4aee-85d0-d6a3aef985e6",
    "hitokoto": "我们是圣徒，是智者，是行旅之人；我们如赶路的马夫额触天涯，我们即将奔赴一场浩劫，却如赴盛宴。",
    "type": "k",
    "from": "周天嘉",
    "from_who": "周天嘉",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616762013",
    "length": 46
  },
  {
    "id": 7438,
    "uuid": "7ee7f854-f05b-43cf-85ba-a59bc31831dc",
    "hitokoto": "学而不厌，诲人不倦。",
    "type": "k",
    "from": "论语·述而",
    "from_who": "孔子",
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619420097",
    "length": 10
  },
  {
    "id": 7439,
    "uuid": "dd72e127-5e7b-4581-a11b-0a978992455c",
    "hitokoto": "为者常成，行者常至。",
    "type": "k",
    "from": "晏子春秋·内篇杂下",
    "from_who": null,
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619420152",
    "length": 10
  },
  {
    "id": 7440,
    "uuid": "c6d9d4c5-4634-4755-b01b-2fdc7ed11050",
    "hitokoto": "出入相友，守望相助。",
    "type": "k",
    "from": "每日一习话",
    "from_who": null,
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619420236",
    "length": 10
  },
  {
    "id": 7441,
    "uuid": "c7feac39-6d62-43b8-8b08-2c82e0e1fc18",
    "hitokoto": "行百里者半九十。",
    "type": "k",
    "from": "战国策·秦策五·谓秦王",
    "from_who": null,
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619420404",
    "length": 8
  },
  {
    "id": 7442,
    "uuid": "3a99e352-d34c-4a71-bf3a-e60bfda3cb00",
    "hitokoto": "有志者，事竟成。",
    "type": "k",
    "from": "后汉书·耿弇传",
    "from_who": null,
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619420469",
    "length": 8
  },
  {
    "id": 7443,
    "uuid": "86b3fe81-dd36-42bd-80ce-1664cd37f118",
    "hitokoto": "取法于上，仅得为中；取法于中，故为其下。",
    "type": "k",
    "from": "每日一习话",
    "from_who": null,
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619420537",
    "length": 20
  },
  {
    "id": 7444,
    "uuid": "44fa58e1-2bec-4ea8-bdd9-5602ea359306",
    "hitokoto": "All is not gold that glitters，But gold will glitter forever。",
    "type": "k",
    "from": "尼采",
    "from_who": null,
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619420637",
    "length": 60
  },
  {
    "id": 7458,
    "uuid": "27fc84b5-c662-4032-ab62-49d78df4621a",
    "hitokoto": "生活中最重要的事情：不是胜利，而是努力；不是征服，而是奋力拼搏。",
    "type": "k",
    "from": "Pierre de Coubertin",
    "from_who": null,
    "creator": "DreamOne",
    "creator_uid": 9209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627129974",
    "length": 32
  },
  {
    "id": 7483,
    "uuid": "15e82029-4760-429e-a0ff-91e67da4051c",
    "hitokoto": "判断一个人是否具备“换位思考”的能力有一个好方法，那就是看他怎样向没有技术背景的人解释技术问题。",
    "type": "k",
    "from": "黑客与画家",
    "from_who": "保罗•格雷厄姆",
    "creator": "DreamOne",
    "creator_uid": 9209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628787094",
    "length": 48
  },
  {
    "id": 7513,
    "uuid": "8c874b63-bff2-4392-9308-587f35f4f9fa",
    "hitokoto": "遗忘比绝望更强有力。",
    "type": "k",
    "from": "西方哲学",
    "from_who": "叔本华",
    "creator": "baresi48",
    "creator_uid": 10455,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1632362450",
    "length": 10
  }
]